import { Typography, Box } from '@mui/material';
import React from 'react';

const DatasourceNameCell = ({ datasourceName, datasourceId }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: 1 }}>
            <Typography variant='body2' sx={{ fontWeight: '600', color: '#0F172A', lineHeight: 1.2 }}>
                {datasourceName}
            </Typography>
            <Typography
                sx={{
                    fontSize: '0.75rem',
                    color: '#64748B',
                    mt: 0.5,
                    fontFamily: 'monospace'
                }}
            >
                {datasourceId}
            </Typography>
        </Box>
    )
}

export default DatasourceNameCell;
